function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * GitHub OAuth protocol. Authenticates GitHub credentials.
 * Does not touch Faucet records, payments, or peer notify.
 */

var GITHUB_TOKEN_URL = 'https://github.com/login/oauth/access_token';
var GITHUB_USER_URL = 'https://api.github.com/user';
function authError(code, httpStatus, title, message) {
  var extra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var err = new Error(message);
  err.code = code;
  err.httpStatus = httpStatus;
  err.title = title;
  err.popupMessage = message;
  Object.assign(err, extra);
  return err;
}
function isAccountValid(createdAt) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  // Current validity criterion: GitHub account must be at least six months old.
  var created = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(created.getTime())) {
    return false;
  }
  var eligibleAt = new Date(created.getTime());
  eligibleAt.setMonth(eligibleAt.getMonth() + 6);
  return now >= eligibleAt.getTime();
}
function exchangeGithubCode(_x) {
  return _exchangeGithubCode.apply(this, arguments);
}
function _exchangeGithubCode() {
  _exchangeGithubCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var clientId, clientSecret, code, redirectUri, body, res, data, msg, err;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          clientId = _ref.clientId, clientSecret = _ref.clientSecret, code = _ref.code, redirectUri = _ref.redirectUri;
          body = new URLSearchParams();
          body.set('client_id', clientId);
          body.set('client_secret', clientSecret);
          body.set('code', code);
          body.set('redirect_uri', redirectUri);
          _context.n = 1;
          return fetch(GITHUB_TOKEN_URL, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body.toString()
          });
        case 1:
          res = _context.v;
          _context.n = 2;
          return res.json()["catch"](function () {
            return {};
          });
        case 2:
          data = _context.v;
          if (!(!res.ok || data.error || !data.access_token)) {
            _context.n = 3;
            break;
          }
          msg = data.error_description || data.error || "token_http_".concat(res.status);
          err = new Error(String(msg));
          err.code = 'github_token_exchange_failed';
          throw err;
        case 3:
          return _context.a(2, {
            access_token: data.access_token,
            token_type: data.token_type || 'bearer',
            scope: data.scope || ''
          });
      }
    }, _callee);
  }));
  return _exchangeGithubCode.apply(this, arguments);
}
function fetchGithubUser(_x2) {
  return _fetchGithubUser.apply(this, arguments);
}
/**
 * Authenticate GitHub credentials (authorization code).
 * Performs GitHub token exchange, profile lookup, and GitHub-specific
 * account checks. Returns a provider identity. Does not touch Faucet state.
 */
function _fetchGithubUser() {
  _fetchGithubUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(accessToken) {
    var res, data, msg, err;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetch(GITHUB_USER_URL, {
            method: 'GET',
            headers: {
              Accept: 'application/vnd.github+json',
              Authorization: "Bearer ".concat(accessToken),
              'User-Agent': 'Saito-Faucet-OAuth',
              'X-GitHub-Api-Version': '2022-11-28'
            }
          });
        case 1:
          res = _context2.v;
          _context2.n = 2;
          return res.json()["catch"](function () {
            return {};
          });
        case 2:
          data = _context2.v;
          if (!(!res.ok || !data.id)) {
            _context2.n = 3;
            break;
          }
          msg = data.message || "user_http_".concat(res.status);
          err = new Error(String(msg));
          err.code = 'github_user_fetch_failed';
          throw err;
        case 3:
          return _context2.a(2, {
            id: String(data.id),
            login: String(data.login || ''),
            name: String(data.name || ''),
            created_at: String(data.created_at || '')
          });
      }
    }, _callee2);
  }));
  return _fetchGithubUser.apply(this, arguments);
}
function authenticateCredentials(_x3) {
  return _authenticateCredentials.apply(this, arguments);
}
function _authenticateCredentials() {
  _authenticateCredentials = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref2) {
    var code, clientId, clientSecret, redirectUri, token, user, provider_user_id;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          code = _ref2.code, clientId = _ref2.clientId, clientSecret = _ref2.clientSecret, redirectUri = _ref2.redirectUri;
          _context3.n = 1;
          return exchangeGithubCode({
            clientId: clientId,
            clientSecret: clientSecret,
            code: code,
            redirectUri: redirectUri
          });
        case 1:
          token = _context3.v;
          _context3.n = 2;
          return fetchGithubUser(token.access_token);
        case 2:
          user = _context3.v;
          token.access_token = '';
          if (!(!user.created_at || !isAccountValid(user.created_at))) {
            _context3.n = 3;
            break;
          }
          throw authError('github_account_too_new', 403, 'GitHub account not eligible', 'Registration requires a GitHub account that is at least six months old.', {
            details: user.login ? "Account: ".concat(user.login) : '',
            login: user.login,
            created_at: user.created_at
          });
        case 3:
          provider_user_id = String(user.id || '').trim();
          if (provider_user_id) {
            _context3.n = 4;
            break;
          }
          throw authError('github_missing_user_id', 502, 'GitHub verification failed', 'GitHub profile did not include a stable user id.');
        case 4:
          return _context3.a(2, {
            provider: 'github',
            provider_user_id: provider_user_id,
            provider_username: String(user.login || ''),
            provider_display_name: String(user.name || user.login || ''),
            provider_account_created_at: Date.parse(user.created_at) || 0
          });
      }
    }, _callee3);
  }));
  return _authenticateCredentials.apply(this, arguments);
}
module.exports = {
  authenticateCredentials: authenticateCredentials
};